import { render, staticRenderFns } from "./SubscriptionListItem.vue?vue&type=template&id=48c34ada&"
import script from "./SubscriptionListItem.vue?vue&type=script&lang=js&"
export * from "./SubscriptionListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports